import React from 'react';
import { AlertTriangle } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/Strategic_Preparedness.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-489">
      <img src={HERO_BG} alt="Strategic Preparedness" className="block absolute inset-0 w-full h-full object-cover" onError={e => {
      e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/1k2RNSeLsdo1YWP3bfFU8J/Strategic-Preparedness.jpg';
    }} data-id="element-490" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-491" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-492">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-493">
          <AlertTriangle className="w-4 h-4" data-id="element-494" />
          Crisis Planning
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-495">
          Preparation and Strategic Planning <br className="hidden md:block" data-id="element-496" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-497">
            for Crisis Situations
          </span>
        </h1>
        <p className="text-lg md:text-xl text-brand-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-498">
          When a critical incident strikes, preparation is everything. We help
          agencies and organizations build, modernize, and stress-test the plans
          that keep people safe under pressure.
        </p>
      </div>
    </section>;
}